<template>
    <div class="bg-white font-sans">
        <div class="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
            <section class="text-center max-w-4xl mx-auto">
                <h2 class="text-4xl lg:text-5xl font-bold">
                    <span class="text-orange-500">Jornada de Sucesso - OverX</span>
                </h2>
                <div class="mt-6 text-black space-y-4 text-base lg:text-lg leading-relaxed">
                    <p>
                        A parceria com iFood trouxe ganhos significativos e relevantes para a OverX. A partir dessa
                        parceria, além de conseguir organizar e qualificar leads da base, foi possível implementar um
                        CRM focado nas tratativas de SDR, gerando um grande impacto nas taxas de conversão de leads
                        qualificados.
                    </p>
                    <p>
                        Com o apoio da OverX, a gestão de leads foi otimizada, permitindo que a base de dados fosse
                        organizada de maneira mais eficaz, e as ações de vendas se tornassem mais ágeis e assertivas,
                        com foco nas oportunidades com maior potencial de conversão.
                    </p>
                    <p>
                        A implementação de estratégias de marketing e automação de processos com a OverX garantiu que a
                        gestão de leads fosse ainda mais eficaz, resultando em aumento significativo na base de leads
                        qualificados para a iFood, além de melhorar a experiência do cliente e otimizar os resultados de
                        vendas.
                    </p>
                </div>
            </section>
        </div>

        <section class="mt-16 bg-orange-500 rounded-t-[3rem]">
            <div class="max-w-7xl mx-auto flex items-center justify-center py-12 px-8">
                <img src="@/assets/overx.png" alt="Logo OverX" class="h-16 md:h-20 lg:h-24">
            </div>
        </section>

    </div>
</template>

<script setup>
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap');

.font-sans {
    font-family: 'Sora', sans-serif;
}
</style>